module.exports = __webpack_public_path__ + "img/digibos.0b3b9a8d.png";